import customHeaders, { getSpace } from "../../common/headers";
import add_icon from './img/add.svg'
import AddBalanceModal from '../../components/AddBalanceModal/index';
import { useDataTable } from "../../common/hooks";
import { ButtonBasic, TableBox, Sceleton } from "@lk-gtcom/ecomlab-components";
import { useEffect, useState, useRef } from "react";
import { KonstantinMasterHttps } from '../../fetchUrls';
import useGeneralStore from "../../store/general";
import { TitlePage } from "../../components/TitlePage/TitlePage";
import { useResponseHandler } from "../../common/auth";
import './Summary.scss'

const Summary = () => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
    const [isModalBalance, setIsModalBalance] = useState(false)
    const [pivotData, setPivotData] = useState([])
    const paginatorRef = useRef()
    const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef)
    const { setLoading, setFetchedData, setHeaders, setSort, setFilters } = setTableFuncs
    const [loadingPivot, setLoadingPivot] = useState(false)

    const fetchTableData = (params, abortController = new AbortController()) => {
        let sort
        let filters

        if (params) {
            [sort, filters] = params
        }

        const orderParam = sort?.[0] ? `?order_param=${sort?.[0]}&order_param_direction=${sort?.[1]}` : ''

        setLoading(true)
        let url = `${KonstantinMasterHttps}/finance/pivot/spending-on-services${orderParam}`

        const body = JSON.stringify({
            filters,
            limit: paginatorRef.current?.limit,
            page: paginatorRef.current?.page,
        })


        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then(json => setTable(json))
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return
                setLoading(false)
            })
    }

    const fetchPivotData = (abortController = new AbortController()) => {
        setLoadingPivot(true)
        let url = `${KonstantinMasterHttps}/finance/pivot/summary-for-period`

        const body = JSON.stringify({})


        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then(json => setPivotData(json?.data?.map((el, ind) => ({ ...el, label: json?.headers?.[ind] }))))
            .catch(handleStatusCode)
            .finally(() => {
                setLoadingPivot(false)
                if (abortController.signal.aborted) return
            })
    }

    useEffect(() => {
        const abortController = new AbortController()
        fetchTableData([], abortController)
        fetchPivotData(abortController)
        return () => abortController.abort()
    }, [selectedSpace])


    // Цвета шапок карточек: фон + цвет текста (начало, поступления, списания, конец периода)
    const summaryHeads = [
        { bg: '#EEF0F4', color: '#0C2037' },
        { bg: '#E7F7EC', color: '#177F3B' },
        { bg: '#FFF1E0', color: '#B85600' },
        { bg: '#E8ECFE', color: '#3347C9' },
    ]

    return (
        <>
            {
                isModalBalance &&
                <AddBalanceModal
                    setIsModalActive={e => setIsModalBalance(false)}
                />
            }

            <div className='summary'>

                <div className='summary__header'>
                    <TitlePage
                        title='Сводная'
                    />
                    <ButtonBasic
                        green
                        width='190px'
                        icon={add_icon}
                        text={'Пополнить баланс'}
                        onClick={e => setIsModalBalance(true)}
                    />
                </div>

                <div className="summary__period">
                    <div className="summary__items-period">
                        {
                            loadingPivot ?
                                [...Array(4)].map((_el, ind) => {
                                    return <Sceleton
                                        width={'300px'}
                                        height={'118px'}
                                    />
                                })
                                :
                                pivotData?.map(({ label, amount, color, symb }, ind) => {
                                    const head = summaryHeads[ind] || summaryHeads[0]
                                    return <div className="summary__item-period" key={amount + ind + label}>
                                        <div className="summary__head-period" style={{ background: head.bg }}>
                                            <span className="summary__text-period" style={{ color: head.color }}>{label}</span>
                                        </div>
                                        <p className="summary__text-sum" style={{ color: head.color }}>{symb ? symb : ''}{amount?.toLocaleString()} ₽</p>
                                    </div>
                                })}
                    </div>
                </div>

                <TitlePage
                    title='Траты на услуги'
                    medium
                />

                <TableBox
                    {...tableProps}
                    ref={paginatorRef}
                    paginator={true}
                    fetchCallback={fetchTableData}
                />
            </div>
        </>
    )
}

export { Summary }
